import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getTimeZoneShortDisplayName } from 'owa-timezone';
import { toPixelString } from 'owa-calendar-surface-core';
import { getAnchorForContextMenu } from 'owa-positioning';
import { IPoint } from '@fluentui/react/lib/Utilities';
import * as trace from 'owa-trace';

const styles = require('./TimeStripHeader.scss');

export interface TimeStripHeaderProps {
    timeZone: string;
    headerWidth?: number;
    onContextMenu?: (timeZone: string, anchorPoint: IPoint) => void;
}

const TimeStripHeader: React.FunctionComponent<TimeStripHeaderProps> = observer(
    function TimeStripHeader(props: TimeStripHeaderProps) {
        const { timeZone, headerWidth, onContextMenu } = props;

        const onContextMenuCallback = React.useCallback(
            (ev: React.MouseEvent<HTMLDivElement>) => {
                ev.preventDefault();

                if (onContextMenu) {
                    onContextMenu(timeZone, getAnchorForContextMenu(ev));
                }
            },
            [timeZone, onContextMenu]
        );

        const timeZoneWidthStyle = { width: toPixelString(headerWidth) };

        return (
            <div
                className={styles.timeZonePanel}
                style={timeZoneWidthStyle}
                onContextMenu={onContextMenuCallback}>
                {getDisplayName(timeZone)}
            </div>
        );
    }
);

export default TimeStripHeader;

function getDisplayName(timeZone: string) {
    let displayName = undefined;

    if (timeZone) {
        try {
            displayName = getTimeZoneShortDisplayName(timeZone);
        } catch (error) {
            trace.errorThatWillCauseAlert(
                '[OSTimeZone] Failed to get timezone short display name for time zone:' + timeZone,
                error
            );
        }
    }

    return displayName;
}
